"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UploadContext = void 0;
var react_1 = require("react");
exports.UploadContext = react_1.createContext({
    open: function () { },
    isDragging: false,
    getDraggerProps: function () { return ({}); },
});
//# sourceMappingURL=UploadContext.js.map